define('app/ui/dialog',['text!./modalBase.html'], function (modalBaseView) {

    return {
        show: function (title, content, options, retainTemplateOnClose, modalClasses, modalDialogSize, addClass) {

            retainTemplateOnClose = !!retainTemplateOnClose;

            if (!modalClasses || !Array.isArray(modalClasses)) {
                modalClasses = [];
            }

            

            $(".temp_exclusive").remove();

            if (!options) options = {};

            if (!content || content === '') {
                content = $('<div />')
                    .addClass('text-center')
                    .append(
                        $('<img />')
                            .attr('src', '/Content/loading.gif')
                            .attr('alt', 'Loading')
                            .attr('title', 'Loading')
                    );
            }


            if (!content.jquery) {
                content = $('<div />').addClass('temp_exclusive').append(content);
            }
            
            var id = 'K' + Math.floor(Math.random() * 10000);
            var backdropId = 'backdrop-' + id;
            var modalTemplate = $(modalBaseView).clone();            
            modalTemplate.attr('id', id); 
            modalTemplate.find('.modal-title').text(title);                      
            modalTemplate.find('.modal-body').append(content);

            for (var i = 0; i < modalClasses.length; i++) {
                modalTemplate.addClass(modalClasses[i]);
            }

            var modalOptions = {};

            if (options.noClose) {
                modalOptions.backdrop = 'static';
                modalOptions.keyboard = false;
                modalTemplate.find('.modal-header .modal-title').addClass('text-center').siblings('.close').remove(); // Make sure this dialog doesn't have a close button.
            }            

            modalTemplate.close = function () {
                modalTemplate.modal('hide');
            };

            modalTemplate.on('hidden.bs.modal', function (e) {
                modalTemplate.modal('dispose');

                if (!retainTemplateOnClose) {                    
                    modalTemplate.remove();
                }
            });

            modalTemplate.on('shown.bs.modal', function (e) {  
                $('.modal-backdrop').first().attr('id', backdropId);
                if (options.onOpen) {
                    options.onOpen(id);
                }
            });

            modalTemplate.isOpen = function () {
                return modalTemplate && modalTemplate.length > 0 && modalTemplate.is(':visible');
            };

            modalTemplate.modal(modalOptions);

            if (options.width) {
                modalTemplate.find('.modal-content').width(options.width);
            }

            if (options.height) {
                modalTemplate.find('.modal-content').height(options.height);
            }

            modalTemplate.changeTitle = function (text) {
                modalTemplate.find('.modal-title').text(text); 
            };

            modalTemplate.adjustSize = function (width, height) {
                var contentElement = modalTemplate.find('.modal-content');
                if (width) {
                    contentElement.width(width);
                }
                if (height) {
                    contentElement.height(height);
                }

                modalTemplate.modal('handleUpdate');
            }

            if (modalDialogSize && typeof(modalDialogSize) === "string") {
                modalTemplate.find('.modal-dialog').addClass(modalDialogSize);
            }

            if (addClass) {
                modalTemplate.find('.modal-dialog').addClass(addClass);
            }

            return modalTemplate;
        },

        closeAll: function () {
            $('.modal').modal('hide');
        }
    };
});
